import Container from './PresetBatchEdit.container';
import PresetBatchEdit from './PresetBatchEdit';

export default Container(PresetBatchEdit);
